module.exports = __webpack_public_path__ + "static/img/orange.5f96972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/orange.jpg
// module id = YxzP
// module chunks = 1